// extracted by mini-css-extract-plugin
export default {"topbarText":"Topbar_topbarText__-bmHq","topbar":"Topbar_topbar__hekgI"};